import { render, staticRenderFns } from "./couponsDown.vue?vue&type=template&id=46fd4bfa&scoped=true&"
import script from "./couponsDown.vue?vue&type=script&lang=js&"
export * from "./couponsDown.vue?vue&type=script&lang=js&"
import style0 from "./couponsDown.vue?vue&type=style&index=0&id=46fd4bfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fd4bfa",
  null
  
)

export default component.exports